import { fireEntryDispatches } from '../kickstart';
import buildNewsletterList from '../newsletter-list';

fireEntryDispatches();

export * from '../kickstart';
export { buildNewsletterList };
